import React from 'react';
import Heading from '../Headers/Heading';
import Art from '../Misc/Art';
import illustration from '../../assets/images/art_1.png';
import serviceHeaderImage from '../../assets/images/services-header.webp';

function ServicesDetailedheader() {
    return (
        <>
            <div className="page-header position-relative">
                <Heading 
                        heading={<h1>Services</h1>}
                        headingClass="heading-very-large dark-1"
                        WrapperComponent={(props) => {
                            return (
                                <div className="page-header-top">
                                    <div className="container">
                                        {props.children}
                                    </div>
                                </div>
                            )
                        }}
                    />
                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={serviceHeaderImage} alt="A Studio NORCAT team member performs scaling in the Motion Capture Volume" />
                    </div>
                </div>
                <Art art={illustration} type="1" />
            </div>
        </>
    );
}

export default ServicesDetailedheader;
